import { ColumnTypes, FilterTypes } from 'commons/table/Constants';
import { Badge } from 'react-bootstrap';
import { WrapTextAndCenterAlign } from 'components/WrapText';
import { formatDateWithTime } from 'services/MomentUtils';

const SWITCHES_MAP = [
  { key: 'false', value: 'Non-Associated' },
  { key: 'true', value: 'Associated' },
]

export const UNKNOWN = "Unknown";

export const UNPROCESSED_FAX_PRIORITY = {
  ALERT: "Alert",
  CONTACT: "Contact",
  REVIEW: "Review",
  PROCESSING: "Processing",
  UNLINKED: "Unlinked",
  OTHER: "Other",
}

export const UNPROCESSED_FAX_PRIORITY_SINGLE_SELECT_OPTIONS = [
  { key: "", value: "" },
  { key: "ALERT", value: "Alert" },
  { key: "CONTACT", value: "Contact" },
  { key: "PROCESSING", value: "Processing" },
  { key: "REVIEW", value: "Review" },
  { key: "UNLINKED", value: "Unlinked" },
  { key: "OTHER", value: "Other" },
]

export const UNPROCESSED_FAX_PROGRAM_TYPE = {
  SWITCH: "SWITCH",
  NON_SWITCH: "NON_SWITCH",
  UNKNOWN: "UNKNOWN"
}

export const FAX_DETAILS_UI_RULES = {
  [UNPROCESSED_FAX_PROGRAM_TYPE.SWITCH]: {
    key: UNPROCESSED_FAX_PROGRAM_TYPE.SWITCH,
    headingText: "Link Fax Page To Switch",
    showPriority: true,
    showTags: true,
    showLinkSection: true,
    showNotes: true,
    showMemberSwitchList: true,
    showDiscard: true,
    showAssociatedSwitch: true,
    navigateBackAfterTagSave: false,
    tagsButtonLabel: "Save Tags",
    linkButtonLabel: "Link Switch(es)",
    linkFieldLabels: {
      identifier: "Switch Id",
      referenceField: "Change Order",
      additionalField: "Additional Pages",
    },
  },
  [UNPROCESSED_FAX_PROGRAM_TYPE.NON_SWITCH]: {
    key: UNPROCESSED_FAX_PROGRAM_TYPE.NON_SWITCH,
    headingText: "Link Fax to Non-Switch Entity",
    showPriority: true,
    showTags: true,
    showLinkSection: true,
    showNotes: true,
    showPrescriberList: true,
    showDiscard: true,
    showAssociatedSwitch: true,
    navigateBackAfterTagSave: false,
    tagsButtonLabel: "Save Tags",
    linkButtonLabel: "Link and Archive",
    linkFieldLabels: {
      identifier: "Prescriber NPI",
      referenceField: "Fax Reference ID",
      additionalField: "Link Pages",
    },
  },
  [UNPROCESSED_FAX_PROGRAM_TYPE.UNKNOWN]: {
    key: UNPROCESSED_FAX_PROGRAM_TYPE.UNKNOWN,
    headingText: "Link Fax Program Tag To Fax",
    showPriority: true,
    showTags: true,
    showLinkSection: false,
    showNotes: false,
    showMemberSwitchList: false,
    showDiscard: false,
    showAssociatedSwitch: false,
    navigateBackAfterTagSave: true,
    tagsButtonLabel: "Save and Move",
    linkButtonLabel: "Link Switch(es)",
    linkFieldLabels: {
      identifier: "Switch Id",
      referenceField: "Change Order",
      additionalField: "Additional Pages",
    },
  },
};
 
export const DEFAULT_UNPROCESSED_FAX_LIST_SORTING = [
  { id: "generatedDate", desc: true, isDefault: true },
];

export const DEFAULT_UNPROCESSED_FAX_LIST_FILTER = [
  { id: "associatedSwitchId", value: false, faxProgramType: [UNPROCESSED_FAX_PROGRAM_TYPE.SWITCH], isdefault: true, },
  { id: "showMyRecentsOnly", value: false },
]

export const UNPROCESSED_FAX_PROGRAM_TYPE_LIST_COLUMNS = (handlePriorityClick) => [
    {
        header: "Fax Program",
        accessor: "faxProgramTypeName",
        accessorKey: "faxProgramTypeName",
        columnType: ColumnTypes.Text,
        width: 300,
        enableSorting: true,
        enableColumnFilter: true,
        filterType: FilterTypes.SearchableInput,
    },
    {
        header: "Fax Count",
        accessor: "faxCount",
        accessorKey: "faxCount",
        columnType: ColumnTypes.Text,
        width: 25,
        enableSorting: true,
    },
    {
        header: "Priority (Total)",
        accessor: "totalPriorityFaxCount",
        accessorKey: "totalPriorityFaxCount",
        width: 100,
        columnType: ColumnTypes.Custom,
        customComponent: (value, row) => {
            const priorityCount = row.original.totalPriorityFaxCount;
            const faxCount = row.original.faxCount;
            if (faxCount === 0) {
                return <span>N/A</span>;
            } else if (priorityCount && priorityCount > 0) {
                return (
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '5px' }}>
                        <p style={{ margin: 0 }}>{priorityCount} {priorityCount === 1 ? 'Fax' : 'Faxes'}</p>
                        <a href="#" onClick={(e) => { e.preventDefault(); e.stopPropagation(); handlePriorityClick(row); }}>Click to View</a>
                    </div>
                );
            }
            return <p style={{ margin: 0 }}>{priorityCount || 0} Faxes</p>;
        },
        enableSorting: true,
    },
    {
        header: "Date Received",
        accessor: "dateReceived",
        accessorKey: "dateReceived",
        columnType: ColumnTypes.Custom,
        width: 100,
        enableSorting: true,
        customComponent: (value, row) => {
            const faxCount = row.original.faxCount;
            if (faxCount === 0) {
                return <span>N/A</span>;
            }
            return <span>{formatDateWithTime(value)}</span>;
        },
    },
];

export const UNPROCESSED_FAX_PROGRAM_TYPE_MODAL_COLUMNS = () => [
    {
        header: "Priority Tag Type",
        accessor: "priority",
        accessorKey: "priority",
        columnType: ColumnTypes.Text,
        width: 100,
        enableSorting: true,
    },
    {
        header: "Fax Count",
        accessor: "count",
        accessorKey: "count",
        width: 50,
        columnType: ColumnTypes.Text,
        enableSorting: true,
    },
];

export const UNPROCESSED_FAX_LIST_COLUMNS = (
  faxTagList,
  switchAdminList,
  handleToggle,
  isShowMyRecentsDisabled,
  renderLastModifiedDateCol,
  faxDocumentHeader = "Fax Document",
  hiddenColumns = [],
  lockColumnSelection = [],
) => {
  const allColumns = [
    {
      header: faxDocumentHeader,
      accessor: 'faxFileKey',
      accessorKey: 'faxFileKey',
      enableSorting: true,
      columnType: ColumnTypes.Text,
      width: 400,
      enableColumnFilter: true,
      filterType: FilterTypes.SearchableInput,
    },
    {
      header: "Tags",
      accessor: "tags",
      accessorKey: "tags",
      size: 60,
      enableSorting: false,
      enableColumnFilter: true,
      columnType: ColumnTypes.Custom,
      customComponent: (value) => {
        if (value && value.length > 0) {
          return (
            <div>
              {value.map((tag, index) => (
                <Badge key={index} bg="secondary" className="me-1 mb-1">
                  {tag}
                </Badge>
              ))}
            </div>
          );
        }
        return <></>;
      },
      filterType: FilterTypes.MultiSelect,
      filterOptions: faxTagList,
    },
    {
      header: 'Fax Identifier',
      accessor: 'faxInfoShortIdentifier',
      accessorKey: 'faxInfoShortIdentifier',
      columnType: ColumnTypes.Text,
      filterType: FilterTypes.SearchableInput,
      enableColumnFilter: true,
      width: 300,
    },
    {
      header: 'Reference ID',
      accessor: 'faxReferenceId',
      accessorKey: 'faxReferenceId',
      columnType: ColumnTypes.Text,
      filterType: FilterTypes.SearchableInput,
      enableColumnFilter: true,
      width: 300,
    },
    {
      header: 'Priority',
      accessor: 'faxPriority',
      accessorKey: 'faxPriority',
      width: 200,
      columnType: ColumnTypes.Custom,
      enableColumnFilter: true,
      enableSorting: true,
      filterType: FilterTypes.SingleSelect,
      customComponent: (value) => (
        <WrapTextAndCenterAlign>
          {UNPROCESSED_FAX_PRIORITY[value]}
        </WrapTextAndCenterAlign>
      ),
      filterOptions:
        UNPROCESSED_FAX_PRIORITY_SINGLE_SELECT_OPTIONS,
    },
    {
      header: 'Associated Switch',
      accessor: 'associatedSwitchId',
      accessorKey: 'associatedSwitchId',
      width: 200,
      columnType: ColumnTypes.Text,
      enableColumnFilter: true,
      enableSorting: true,
      filterType: FilterTypes.SingleSelect,
      filterOptions: SWITCHES_MAP,
      filterReturnKey: true,
    },
    {
      header: 'Last Modified Date',
      accessor: 'lastModifiedDate',
      accessorKey: 'lastModifiedDate',
      columnType: ColumnTypes.DateColumn,
      enableSorting: true,
    },
    {
      header: 'Received Date',
      accessor: 'generatedDate',
      accessorKey: 'generatedDate',
      columnType: ColumnTypes.DateColumn,
      enableSorting: true,
    },
    {
      header: 'Prescriber NPI',
      accessor: 'prescriberNPI',
      accessorKey: 'prescriberNPI',
      width: 200,
      columnType: ColumnTypes.Text,
      enableColumnFilter: true,
      enableSorting: true,
      filterReturnKey: true,
      filterType: FilterTypes.SearchableInput,
    },
    {
      header: "Recently Viewed Users",
      accessor: 'recentlyViewedUsers',
      accessorKey: 'recentlyViewedUsers',
      columnType: ColumnTypes.Custom,
      enableColumnFilter: true,
      enableSorting: true,
      filterType: FilterTypes.MultiSelect,
      filterOptions: switchAdminList,
      hasToggleButton: true,
      handleToggle,
      isDisabled: isShowMyRecentsDisabled(),
      customComponent: (value, row) =>
        renderLastModifiedDateCol(
          row.original.lastViewedAt,
          row.original.lastViewedBy
        ),
    },
  ];

  const filteredColumns = allColumns.filter(
    (col) => !hiddenColumns.includes(col.accessorKey)
  );

  return filteredColumns.map(col => {
    const lockedColumn = lockColumnSelection.find(lock => lock.id === col.accessorKey);
    if (lockedColumn) {
      col.isSelectionLocked = true;      
      if (lockedColumn.value) col.lockedValues = lockedColumn.value;
    } 
    return col;
  });
};

export const UNPROCESSED_FAX_LIST_HIDDEN_COLUMNS = {
  [UNPROCESSED_FAX_PROGRAM_TYPE.SWITCH] : ["prescriberNPI", "faxReferenceId"],
  [UNPROCESSED_FAX_PROGRAM_TYPE.NON_SWITCH]: ["associatedSwitchId", "faxInfoShortIdentifier"],
  [UNPROCESSED_FAX_PROGRAM_TYPE.UNKNOWN]: ["tags", "faxInfoShortIdentifier", "prescriberNPI", "associatedSwitchId", "faxReferenceId"]
}
